<div #container class="containerBubble" [style.width]="size" >
  <div #bubble class="help-bubble">
    <mat-icon (click)="togglePopup()" class="icon" [ngClass]="{'clicked': isPopupVisible}" [style.fontSize]="size" [style.width]="size" [style.height]="size">help</mat-icon>
  </div>

  <div id="info-box" *ngIf="isPopupVisible" class="info-box">
    <div #popOver class="info-box-container" [style.left]="popOverLeft" [style.max-width]="popWidth" [style.min-width]="popMinWidth">
      <div *ngIf="!help">{{ text }}</div>
      <div *ngFor="let image of images" class="image-bubble">
        <img [src]="image" alt="Image">
      </div>

      <ng-container *ngTemplateOutlet="template"></ng-container>

      <a *ngIf="link" [href]="link" target="_blank" class="voir-plus-link">{{'click_here' | translate}}</a>
    </div>
  </div>
</div>